const baseContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "marketplace",
    file: {},
    isUpdated: false,
    colorMix: {
      flag: true,
      color1: "#000000",
      color2: "#000000",
      isUpdated: false,
    },
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

const createMarketPlaceEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseContent,
    data: {
      ...baseContent.data,
      key,
    },
    translation: {
      ...baseContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const marketPlaceEntries = [
  { title: "Add Avatar", key: "addAvatar" },
  { title: "Auto match", key: "autoMatch" },
  { title: "Add content", key: "addContent" },
  { title: "Advertise", key: "advertise" },
];

const marketPlace = marketPlaceEntries.map(({ title, key }) => createMarketPlaceEntry(title, key));

export { marketPlace };
